<template>
    <div class="searchCinemaWrap">
        <!-- <nav-bar></nav-bar> -->
        <div>
            <div class="serachBar fr ac jsb">
                <div class="inputWrap fr ac">
                    <img src="../../../static/imgs/movie/search.png" alt />
                    <input @change="search" v-model="searchVal" type="text" placeholder="影院" />
                </div>
                <span v-show="!showSearch" @click="cancle" class="grey">取消</span>
                <span class="tc" v-show="showSearch" @click="search">搜索</span>
            </div>
            <div
                class="content fc"
                v-infinite-scroll="loadMore"
                infinite-scroll-disabled="loading"
                infinite-scroll-distance="0"
            >
                <div
                    @click="goCinema(item.id)"
                    v-for="(item,index) in cinemaList"
                    :key="index"
                    class="cinemaItem fc"
                >
                    <h3>{{item.name}}</h3>
                    <div class="fr ac jsb">
                        <span class="address ellipsis">{{item.address}}</span>
                        <span v-show="item.distance != 10000">{{item.distance | formatDistance}}km</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
import navBar from "../../components/common/navBar.vue";
export default {
    data() {
        return {
            searchVal: "",
            showSearch: false,
            page: 0,
            cinemaList: [],
            movieid: this.$route.query.movieid,
            citycode: this.$route.query.citycode
        };
    },
    components: {
        navBar
    },
    watch: {
        searchVal(val, oldVal) {
            if (val == "") {
                this.cinemaList = [];
                this.page = 0;
                this.showSearch = false;
            } else if (val.length){
                this.cinemaList = [];
                this.page = 0;
                this.showSearch = true;
            }
        }
    },
    methods: {
        search() {
            if (!this.searchVal) {
                Toast({
                    message: "请输入搜索关键字",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            }
            this.$post({
                // method: "movie.cinema.list",
                method: "movie.new.cinema.list",
                page_no: this.page,
                searchvalue: this.searchVal,
                citycode: this.citycode,
                latitude: this.getLocal("locationInfo") && this.getLocal("locationInfo").lat ? this.getLocal("locationInfo").lat : "",
                longitude: this.getLocal("locationInfo") && this.getLocal("locationInfo").lng ? this.getLocal("locationInfo").lng : ""
            }).then(res => {
                if(JSON.stringify(res.data.cinemalist) != JSON.stringify(this.cinemaList)){
                    console.log(res.data.cinemalist,this.cinemaList)
                    this.cinemaList = this.cinemaList.concat(res.data.cinemalist);
                }
                
            });
        },
        loadMore() {
            if (this.cinemaList.length) {
                this.page++;
                this.search();
            }
        },
        goCinema(id) {
            this.$router.push({
                path: "/cinemaMovieList",
                query: {
                    cinemaid: id,
                    movieid: this.movieid,
                    citycode: this.citycode
                }
            });
        },
        cancle(){
            this.$router.back(-1)
        }
    }
};
</script>
<style scoped lang="scss">
.searchCinemaWrap {
    .serachBar {
        // margin-top: 98px;
        height: 100px;
        background-color: #fff;
        padding: 0 30px;
        box-sizing: border-box;
        font-size: 28px;
        .inputWrap {
            width: 88%;
            height: 60px;
            padding: 0 10px;
            box-sizing: border-box;
            background: #f5f5f5;
            border-radius: 30px;
            img {
                width: 32px;
                height: 32px;
                margin: 0 10px;
            }
            input {
                width: 80%;
                margin-left: 10px;
                background: #f5f5f5;
            }
        }
    }
    .content {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        background: #fff;
        .cinemaItem {
            padding-bottom: 25px;
            border-bottom: 1px solid #c8c7cc;
            h3 {
                font-size: 30px;
                line-height: 80px;
            }
            span {
                font-size: 24px;
            }
            .address {
                width: 80%;
            }
        }
        .cinemaItem:last-of-type {
            border-bottom: none;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/search/searchCinema.vue